import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'extractDatePt',
    standalone: false
})
export class ExtractDatePtPipe implements PipeTransform {
  transform(value: string): any {
    const datePipe = new DatePipe('pt');
    const parsedDate = new Date(value);
    return datePipe.transform(parsedDate, 'dd/MM/yyyy');
  }
}
